export const CHECKOUT_URL = 'https://decisionclinica.impultienda.ar/checkout/trt'

export const PRICE = 'USD 15'

export const TOTAL_VALUE = 'USD 546'
